export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14635.96686c8b.jpg";